<template>
  <div id="page-unlayer" class="px-3">
    <!-- <transition name="fade">
      <MenssageAlert class="w-50 m-auto" :messages="messages" />
    </transition> -->
    <UnlayerHeaderEditor
      :templateId="templateId"
      :templateName="templateName"
      :isLoadingMainAction="isLoadingMainAction"
      :isLoadingAutoSave="isLoadingAutoSave"
      :isLoadingTemplateData="isLoadingTemplateData"
      :messages="messages"
      @mainActionClicked="handleMainAction"
      @themeChanged="loadTemplateData"
      @templateJsonImported="loadTemplateJson"
      @exportHtml="exportHtml"
    />

    <div v-if="themeControl && hasTemplateId && !isPlanTemplate" class="unlayer-container text-center">
      <CSpinner v-if="isLoadingTemplateData" color="primary" style="width: 4rem; height: 4rem" />
      <UnlayerEmailEditor v-else ref="unlayerEmailEditor" :templateDesign="templateDesign" @design:updated="handleAutoSave(templateName)" />
    </div>
    <div v-if="themeControl && isPlanTemplate" class="unlayer-container text-center">
      <CSpinner v-if="isLoadingTemplateData" color="primary" style="width: 4rem; height: 4rem" />
      <UnlayerEmailEditor v-else ref="unlayerEmailEditor" :templateDesign="templateDesign" @design:updated="handleAutoSave(templateName)" />
    </div>
  </div>
</template>

<script>
import UnlayerHeaderEditor from '../components/UnlayerHeaderEditor.vue'
import UnlayerEmailEditor from '../components/UnlayerEmailEditor.vue'
import MenssageAlert from '@/components/MenssageAlert'
import services from '@/services.js'
import { getErrorMessage } from '@/utils/errorHandling.js'
import { DYNAMIC_TEMPLATE_DESTINATION_TYPE } from '@/views/template/constants.js'

export default {
  name: 'page-unlayer',
  components: {
    UnlayerEmailEditor,
    UnlayerHeaderEditor,
    MenssageAlert,
  },
  data() {
    return {
      campaignId: undefined,
      indexChannel: undefined,
      organizationId: undefined,
      templateId: undefined,
      templateData: undefined,
      templateJsonImported: undefined,
      isLoadingTemplateData: false,
      isLoadingMainAction: false,
      isLoadingAutoSave: false,
      messages: [],
    }
  },
  mounted() {
    this.setRouteParamsData()
    if (this.hasTemplateId) {
      this.loadTemplateData()
    }
    if (this.isPlanTemplate) {
      this.loadTemplateData(this.$route.params.templatePlanId)
    }
  },
  computed: {
    templateDesign() {
      return this.templateJsonImported || this.templateData?.htmlBuilderData?.design
    },
    templateName() {
      // return this.templateData?.htmlBuilderData?.TemplateName ?? ''
      return this.templateData?.name ?? ''
    },
    themeControl() {
      return this.$store.state.htmlBuilder.themeControl
    },
    hasTemplateId() {
      return Boolean(this.templateId)
    },
    isDestinationTypeCampaign() {
      return DYNAMIC_TEMPLATE_DESTINATION_TYPE.CAMPAIGN == this.$route.params.dynamicDestinationType
    },
    isDestinationTypeWorkflow() {
      return DYNAMIC_TEMPLATE_DESTINATION_TYPE.WORKFLOW == this.$route.params.dynamicDestinationType
    },
    hasDynamicIndex() {
      return this.$route.params.dynamicIndex >= 0
    },
    isPlanTemplate() {
      return this.$route.name == 'plan-unlayer'
    },
  },
  methods: {
    async exportHtml() {
      let { html } = await this.$refs.unlayerEmailEditor.getHtmlContent()
      console.log(html)
    },
    async createTemplate(templateName) {
      const formData = new FormData()
      if (this.isDestinationTypeCampaign) {
        formData.append('CampaignId', this.$route.params.dynamicId)
      }
      formData.append('Name', templateName)

      const createResponse = await services.createTemplate(this.organizationId, formData)
      this.templateData = createResponse.data.data
    },
    async createPlanTemplate(templateName) {
      const formData = new FormData()
      if (this.isDestinationTypeCampaign) {
        formData.append('CampaignId', this.$route.params.dynamicId)
      }
      formData.append('Name', templateName)

      const createResponse = await services.createTemplate(this.organizationId, formData)
      this.$router.replace({ query: { templateId: createResponse.data.data.emailTemplateId } })
      this.templateId = createResponse.data.data.emailTemplateId
      await this.updateTemplate(templateName, false)
    },
    async updateTemplate(templateName, isCalledByClick) {
      const htmlContent = await this.$refs.unlayerEmailEditor.getHtmlContent()

      const updateBody = {
        name: templateName,
        ...htmlContent,
      }

      updateBody.TemplateName = templateName

      await services.updateTemplate(this.organizationId, this.templateId, updateBody)

      if (isCalledByClick && this.templateId && this.templateName) {
        if (!this.$route.params.dynamicId || !this.hasDynamicIndex) return

        if (this.isDestinationTypeCampaign) {
          this.handleCampaignRedirect()
        }

        if (this.isDestinationTypeWorkflow) {
          this.handleWorkflowRedirect()
        }
      }
    },
    handleCampaignRedirect() {
      this.$router.push({
        name: 'campaignCreator',
        params: {
          messages: [
            {
              status: 'success',
              text: this.$t('templates.messages.template-saved-end-add-campaign', [this.templateName]),
            },
          ],
          campaignId: this.$route.params.dynamicId,
          indexChannel: this.$route.params.dynamicIndex,
          template: {
            contentType: 2, // 1 = simples text || 2 = html
            id: this.templateId,
            name: this.templateName,
            thumbnailUri: `${this.$configs.VUE_APP_ROOT_API}template/email/static/${this.templateId}/thumbnail.html`,
            htmlFileUri: `${this.$configs.VUE_APP_ROOT_API}template/email/static/${this.templateId}/index.jpg`,
          },
        },
      })
    },
    handleWorkflowRedirect() {
      this.$router.push({
        name: 'automationWorkflow',
        params: {
          messages: [
            {
              status: 'success',
              text: this.$t('templates.messages.template-saved-end-add-automation', [this.templateName]),
            },
          ],
          workflowId: this.$route.params.dynamicId,
          indexStep: this.$route.params.dynamicIndex,
          template: {
            contentType: 2, // 1 = simples text || 2 = html
            id: this.templateId,
            name: this.templateName,
            thumbnailUri: `${this.$configs.VUE_APP_ROOT_API}template/email/static/${this.templateId}/thumbnail.html`,
            htmlFileUri: `${this.$configs.VUE_APP_ROOT_API}template/email/static/${this.templateId}/index.jpg`,
            isUnlayer: true,
          },
        },
      })
    },
    updateRouteParams(templateId) {
      let params = this.$route.params.dynamicId ? this.$route.params : ''
      this.$router.push({
        params: { templateId: templateId, ...params },
      })
    },
    async handleMainAction(templateName) {
      try {
        this.isLoadingMainAction = true
        this.isLoadingAutoSave = true
        const isCalledByClick = true
        if (this.templateId) {
          await this.updateTemplate(templateName, isCalledByClick)
        } else {
          if (this.isPlanTemplate) {
            let templateCopyName = templateName
            await this.createPlanTemplate(templateCopyName)
          } else {
            await this.createTemplate(templateName)
            this.updateRouteParams(this.templateData.emailTemplateId)
          }
        }

        this.messages = [
          {
            status: 'success',
            text: this.$t('unlayer.emailEditor.save.success'),
          },
        ]
      } catch (error) {
        this.messages = [getErrorMessage(error?.response?.data)]
      } finally {
        this.isLoadingMainAction = false
        this.isLoadingAutoSave = false
      }
    },
    async handleAutoSave(templateName) {
      try {
        this.isLoadingAutoSave = true
        if (this.isPlanTemplate && !this.hasTemplateId) {
          this.handleMainAction(templateName)
        } else {
          await this.updateTemplate(templateName)
        }
      } catch (error) {
        this.messages = [getErrorMessage(error?.response?.data)]
      } finally {
        this.isLoadingAutoSave = false
      }
    },
    setRouteParamsData() {
      this.organizationId = this.$route.params.organizationId
      this.templateId = this.$route.params.templateId ?? null
    },
    async loadTemplateData(planTemplateId = null) {
      try {
        let templateResponse = null
        let ids = planTemplateId ?? this.templateId
        this.isLoadingTemplateData = true

        if (this.isPlanTemplate && !this.hasTemplateId) {
          templateResponse = await services.getDefaultTemplate(ids)
        } else {
          templateResponse = await services.getTemplate(this.organizationId, ids)
        }

        // const templateResponse = await services.getTemplate(this.organizationId, this.templateId)
        this.templateData = templateResponse.data.data

        // ? Verifica se é um novo template e cria um nome diferente para que não haja conflito de nomes
        if (this.isPlanTemplate && !this.hasTemplateId) {
          let name = templateResponse.data.data.name + '.copy_' + new Date().getTime().toString().slice(9)
          this.templateData.name = name
        }
      } catch (error) {
        this.messages = [getErrorMessage(error?.response?.data)]
        await setTimeout(() => this.$router.push({ name: 'new-template-lits' }), 2000)
      } finally {
        this.isLoadingTemplateData = false
      }
    },
    loadTemplateJson(templateJson) {
      try {
        this.isLoadingTemplateData = true
        this.templateJsonImported = templateJson
      } catch (error) {
        this.messages = [getErrorMessage(error)]
      } finally {
        this.isLoadingTemplateData = false
      }
    },
  },
  beforeRouteUpdate(to, _, next) {
    if (to.name === 'unlayer' && this.hasTemplateId) {
      this.$router.go(-2)
    }
    next()
  },
}
</script>
